import { render, staticRenderFns } from "./AssignRulesModal.vue?vue&type=template&id=45f6de5e"
import script from "./AssignRulesModal.vue?vue&type=script&lang=js"
export * from "./AssignRulesModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports